import { SelectedMaterialUUID } from './selectedMaterialsTypes';

export class SelectedMaterialCache {
  static selectedMaterialInCreateMessageForm() {
    return 'selected-material-in-create-message-form';
  }

  static selectedCompanyMaterialInCreateMessageForm() {
    return 'selected-company-material-in-create-message-form';
  }

  static downloadUrls(uuid: SelectedMaterialUUID) {
    return `selected-material-${uuid}-download-urls`;
  }
}
